import {RepositoryNotLoading} from "./Repository";

const resource = 'v2/regions';

export default {
    listAvailable() {
        return RepositoryNotLoading.get(`${resource}/available-regions`);
    },
    listSuggestPlace(search, voyageId = '', order = '') {
        return RepositoryNotLoading.get(`${resource}/suggest-distance`, {params: {search, voyage_id: voyageId, order}});
    }
}
